import moment from 'moment';

export const CARD_DATE_FORMAT = 'M/D/YYYY';

export const formatCardDate = (value?: string): string => {
	if (!value) return '';
	const parsed = moment.parseZone(value, moment.ISO_8601, true);
	return parsed.isValid() ? parsed.format(CARD_DATE_FORMAT) : value;
};

export const formatRunTime = (seconds?: number | null) => {
	if (!seconds) return '-';

	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;

	if (!hours) return `${mins} min`;
	return mins ? `${hours} hr ${mins} min` : `${hours} hr`;
};